module.exports = __webpack_public_path__ + "media/gedicht.0943bbbc.mp3";